import crypto from 'crypto-js';

const generateHash = (message: string, secret: crypto.lib.WordArray) => {
  const hash = crypto.HmacSHA256(message, secret);
  let hashInBase64 = crypto.enc.Base64.stringify(hash);
  hashInBase64 = hashInBase64.replace(/\//g, '_').replace(/\+/g, '-').replace(/=/g, '');
  return hashInBase64;
};

// eslint-disable-next-line max-params -- needs four parameters
const getCbisHmac = (appId: string, secret: string, version: string, timestamp: number) => {
  const decodedSecret = crypto.enc.Base64.parse(secret);
  const message = `${appId}-${version}-${timestamp}`;
  return generateHash(message, decodedSecret);
};

export default getCbisHmac;
